module.exports = __webpack_public_path__ + "static/media/vScript-Pharm-Path.49459cb2.svg";